import './Home.scss';
import Card from '../../Components/Card/Card';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getArticles } from '../../redux/actions';
import {v4 as uuidv4} from 'uuid';
import { Link } from 'react-router-dom';

const Home = (props) => {
  const { articles } = useSelector(state => ({
    ...state.articlesReducer,
  }))

  const dispatch = useDispatch();

  useEffect(() => {
    if (articles.length === 0) {
      dispatch(getArticles());
    }
  },[articles.length, dispatch])

  return (
    <>
      <h1 className='home-title'>Tous les articles</h1>
      <div className='container-cards'>
        {articles.map(item => {
          return (
            <Card key={uuidv4()}>
              <h2>{item.title}</h2>
              <Link 
                className="stretched-link"
                to={`article/${item.title.replace(/\s+/g, "-").trim()}`}
                state={{ 
                  title: item.title,
                  body: item.body,
                }}
              >Lire l'article</Link>
            </Card>
          )
        })}
      </div>
    </>
  );
}

export default Home;